<template>
  <el-container class="trackQuery" v-if="showTrackQuery">
    <!--  轨迹查询-->
    <MyMap
      v-if="defaultMap"
      ref="mapRef"
      @drawArea="getDrawArea"
      :showOperationPoint="true"
    >
      <template v-slot:back>
        <el-button @click="mapOpertionBack">退出</el-button>
      </template>
    </MyMap>
    <mapSelectTransfer
      v-else
      class="box-map"
      ref="mapSelectRef"
      :allCameraList="videoData"
      @opertionBack="opertionBack"
    ></mapSelectTransfer>
    <h-frame
      type="left"
      width="370px"
      :isShowOpenBtn="false"
      :isShowOpenIcon="true"
      v-model:defaultOpen="isOpenFrame"
    >
      <div class="map-over">
        <el-input v-model="clueTaskName" clearable placeholder="请输入关键词">
          <template #prefix>
            <i class="iconfont icon-31sousuo"></i>
          </template>
        </el-input>

        <div class="map-over-center">
          <search-box
            ref="searchBoxRef"
            v-model:searchRangeState="searchRangeState"
            @selectFeature="getSelectFeature"
            @openMapOperation="openOperation"
            @opentaskDetail="opentaskDetail"
            @clickSearchPerson="searchPersonMethod"
            @openSelectCamera="openSelectCamera"
          ></search-box>
        </div>

        <!-- <h-unfold-box @refreshTableEmit="unfold()" v-show="flag"></h-unfold-box> -->
      </div>
    </h-frame>
    <div class="openBtn" @click="clickClose"></div>
    <!-- showOpenLine -->
    <div class="openLine" v-if="showOpenLine">
      <span @click="mapLineBack"
        ><h-icon
          icon="icon-guanbi2"
          style="color: red; margin-right: 4px"
        ></h-icon
        >退出</span
      >
      <span @click="mapLineOpenClose">
        <h-icon
          :icon="mapLineOpen ? 'icon-zanting' : 'icon-zhibohuifang'"
        ></h-icon>
        {{ mapLineOpen ? "暂停" : "播放" }}
      </span>
      <el-popover
        v-model="showTimesPopover"
        ref="popvoer"
        trigger="click"
        placement="top"
        popper-class="popoverSpeed"
        width="50px"
      >
        <div class="speedTimes">
          <template v-for="(item, index) in [1, 2, 4, 8]" :key="index">
            <span @click="mapLineOpenTimes(item)">{{ item + "X" }}</span>
          </template>
        </div>
        <template #reference
          ><span>{{ mapTimes }}X</span>
        </template>
      </el-popover>
    </div>
    <map-reminder-video
      id="marker"
      :itemInfo="mapDataItem"
      v-show="showMapRender"
      @close="close"
    ></map-reminder-video>
    <mapArrayPoint
      id="mapArrayPointDom"
      v-show="showArrayPointDom"
      :pointInfo="mapArrayPointData"
      @emitPointClick="getArrayPoint"
      @closeReminder="closeArrayPointDom"
    ></mapArrayPoint>
    <map-reminder-line
      id="Line"
      v-show="showMapLineRender"
      :itemInfo="mapLineItem"
      @close="close"
    ></map-reminder-line>
    <create-task
      class="create-task"
      v-if="showCreateTask"
      v-model:selectData="selectPoint"
      @closeCreateTaks="closeTask"
    ></create-task>
    <search-person
      ref="searchPersonRef"
      v-if="showSearchPerson"
      :searchParams="searchParams"
      :trackMapRef="mapRef"
      v-model:queryFeature="queryFeature"
      @getPositionSearch="getPositionSearch"
      @handleMapLineNode="handleMapLineNode"
      @startMapLine="mapLineDraw"
      @closeSearchPerson="closeSearchPerson"
    ></search-person>
  </el-container>
  <taskDetailDialog
    v-else
    v-model:editTaskInfo="editTaskInfo"
    @hideTrackQuery="trackQuery"
  ></taskDetailDialog>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  onMounted,
  nextTick,
  watch,
  watchEffect,
  computed,
  onUnmounted,
} from "vue";
import { ElMessage } from "element-plus";
import util from "@util/js";
import moment from "moment";
import _ from "lodash";
import { useRouter } from "vue-router";
import handleCoordinates from "@/components/map/js/modular/handleCoordinates";
import searchBox from "./components/searchBox.vue";

import MyMap from "@/components/map/MyMap.vue";
import mapReminderVideo from "./components/mapReminderVideo.vue";
import mapReminderLine from "./components/mapReminderLine.vue";
import createTask from "./components/createTask.vue";
import searchPerson from "./components/searchPerson.vue";
import searchRange from "./components/searchRange.vue";
import taskDetailDialog from "./components/taskDetailDialog.vue";
import { queryRealVideoTree } from "@/api/videoControl/videoApi.js";

export default defineComponent({
  name: "trackQuery",
  components: {
    searchBox,
    MyMap,
    mapReminderVideo,
    mapReminderLine,
    createTask,
    taskDetailDialog,
    searchPerson,
    searchRange,
  },
  props: {},
  setup(props) {
    const state = reactive({
      uniqueVisible: false,
      isOpenFrame: true,
      defaultMap: true, //默认地图和选摄像机地图
      flag: false,
      showTrackQuery: true, // 显示视图研判
      showOpenLine: false, // 显示路径播放暂停
      playNumber: 0, // 显示路径播放暂停
      clueTaskName: "",
      targetNum: "0",
      mapFeatures: "",
      videoData: null, // 所有摄像头点位数据
      showMapRender: false, // 点位信息展示状态
      mapDataItem: null, // 点位信息
      showCreateTask: false, // 点位信息
      selectPoint: [], // 绘制区域内点位信息
      editTaskInfo: {
        beginningClueTaskId: "",
        endTime: "",
        startTime: "",
        clueTaskId: "",
      },
      showSearchPerson: false, // 以图寻人组件
      showSearchRange: false, // 搜索范围
      searchParams: {}, // 以图寻人接口参数
      mapLineOpen: false, // 以图寻人接口参数
      mapTimes: 1, // 地图路径播放倍速
      showTimesPopover: true, // 地图路径播放倍速选项隐藏
      showMapLineRender: false, // 地图路径节点详情展示
      mapLineItem: null, // 节点点位信息
      showArrayPointDom: false,
      mapArrayPointData: [], //聚集点位弹窗详情
      searchRangeState: {}, //搜索范围选择的数据
      queryFeature: "0", //判断搜索机动车人脸等

      visiable: false, //图片寻人组件
      transferVisible: false, //穿梭框
    });
    const refData = toRefs(state);
    const mapRef = ref();
    const searchBoxRef = ref();
    const searchPersonRef = ref();
    const popvoer = ref();
    const router = useRouter();
    const { setPoint, reversePoint, setVideoPoint, reverseVideoPoint } =
      handleCoordinates();
    // 获取区域树中摄像头数据
    const trackQuery = async () => {
      state.showTrackQuery = true;
      queryRealVideoTreeAsync();
    };
    // 获取区域树中摄像头数据
    const queryRealVideoTreeAsync = async () => {
      const res = await queryRealVideoTree();
      state.videoData = res.cameraBaseDtls;
      pointInfoArray(res.cameraBaseDtls);
    };
    // 添加接口中数据点位
    const pointInfoArray = (list) => {
      const array = list.filter((item, index) => {
        if (item.longitude && item.latitude) {
          item.location = setVideoPoint([
            Number(item.longitude),
            Number(item.latitude),
          ]);
          return item;
        }
      });
      const newList = array.map((element, index) => {
        const pointInfo = {
          name: "",
          item: element,
          id: index + 1,
          type: 1,
          showType: 2,
          poiType: 3401,
          location: element.location,
          click: (e) => {
            state.showArrayPointDom = false;
            if (e.length > 1) {
              handleMapArrayClick(e);
              nextTick(() => {
                state.mapArrayPointData = e;
              });
            } else {
              handleMapIconClick(e, 2);
              nextTick(() => {
                state.mapDataItem = element;
              });
            }
            // handleMapIconClick(e);
            // nextTick(() => {
            //   state.mapDataItem = element;
            // });
          },
        };
        return pointInfo;
      });

      nextTick(() => {
        mapRef.value && mapRef.value.loadMarker(newList);
      });
    };
    // 展示点位详情
    const handleMapIconClick = (e, hz = 1) => {
      state.showMapRender = true;
      const dom = document.getElementById("marker");
      const pos = e[0].values_.location;
      const drawOption = {
        positioning: "bottom-center",
        offset: [0, -75],
        stopEvent: false,
      };
      mapRef.value.drawPointInfo(
        dom,
        hz == 1 ? setVideoPoint(pos) : pos,
        drawOption
      );
      mapRef.value &&
        mapRef.value.mapLocation(hz == 1 ? setVideoPoint(pos) : pos, 16);
    };
    //展示多个点位详情
    const handleMapArrayClick = (e) => {
      state.showArrayPointDom = true;
      const dom = document.getElementById("mapArrayPointDom");
      let pos = e[0].values_.location;
      let drawOption = {
        positioning: "bottom-center",
        offset: [0, -30],
        stopEvent: false,
      };
      mapRef.value && mapRef.value.drawPointInfo(dom, pos, drawOption);
    };
    //聚合点列表点击展示弹框
    const getArrayPoint = (val) => {
      //需要对传过来啊的值做一层包裹适用handleMapIconClick方法
      const e = {
        values_: val,
      };
      if (val.poiType == 3401) {
        mapRef.value && mapRef.value.mapLocation(val.location, 18);
        closeArrayPointDom();
      }
      handleMapIconClick([e]);
      state.mapDataItem = val.item;
    };
    //关闭多个点位详情
    const closeArrayPointDom = () => {
      state.showArrayPointDom = false;
    };
    // 展示路径中节点详情
    const handleMapLineNode = (e) => {
      if (e == undefined) return;
      state.showMapLineRender = true;
      state.mapLineItem = e;
      const dom = document.getElementById("Line");
      const pos = e.location;
      const drawOption = {
        positioning: "bottom-center",
        offset: [0, -50],
        stopEvent: false,
      };
      mapRef.value && mapRef.value.drawPointInfo(dom, pos, drawOption);
      mapRef.value && mapRef.value.mapLocation(pos, 14);
    };

    // 展示地图操作按钮
    const openOperation = (e) => {
      if (!state.videoData) {
        ElMessage.warning("请稍等正在加载摄像机点位");
      } else {
        mapRef.value && mapRef.value.opertionBtn();
      }
    };
    // 展示地图操作按钮
    const mapOpertionBack = (e) => {
      mapRef.value && mapRef.value.opertionBack();
    };

    //渲染路径
    const mapLineDraw = (val) => {
      if (state.playNumber !== 0) {
        mapLineBack();
      }
      setTimeout(() => {
        let polyline = [];
        val.forEach((item, index) => {
          let polylineObj = {
            num: index + 1 + "",
            poiType: 3410,
            poiTypeMove: 3409,
            showMovePoint: true,
            info: item,
            location: setVideoPoint([
              Number(item.longitude),
              Number(item.latitude),
            ]),
            click: (e) => {
              handleMapLineNode(e);
            },
          };
          polyline.push(polylineObj);
        });
        mapRef.value && mapRef.value.clickMapLineInit();
        mapRef.value && mapRef.value.clickClearLine();
        mapRef.value && mapRef.value.clickDrawLine(polyline);
        let lineMarker = mapRef.value && mapRef.value.getLineDistance();
        mapLineOpenClose();
        lineMarker.i = 1;
        const time = setInterval(() => {
          if (lineMarker.distance == -1) {
            handleMapLineNode(polyline[lineMarker.i - 1]);
            clearInterval(time);
            palyOver();
          }
        }, 100);
        lineMarker.vectorLayer.on("postrender", () => {
          if (lineMarker.distance == 0) {
            handleMapLineNode(polyline[lineMarker.i - 1]);
          }
        });
        setTimeout(() => {
          handleMapLineNode(polyline[0]);
        }, 200);
      }, 300);
    };
    //地图路径退出
    const mapLineBack = () => {
      mapRef.value && mapRef.value.stopLine();
      if (searchPersonRef.value) searchPersonRef.value.slotDisabled = false;
      //退出前需要先暂停，而且需要加延时。否则出问题
      setTimeout(() => {
        close();
        state.mapLineOpen = false;
        state.mapTimes = 1;
        state.showOpenLine = false;
        mapRef.value && mapRef.value.clickClearLine();
      }, 100);
    };
    //地图路径播放倍速
    const mapLineOpenTimes = (item) => {
      state.mapTimes = item;
      popvoer.value.hide();
      mapRef.value && mapRef.value.changeSpeed(item * 10);
    };
    //地图路径播放
    const mapLineOpenClose = () => {
      state.showOpenLine = true;
      state.mapLineOpen = !state.mapLineOpen;
      if (state.mapLineOpen) {
        mapRef.value && mapRef.value.startLine();
      } else {
        mapRef.value && mapRef.value.stopLine();
      }
    };
    //播放结束
    const palyOver = () => {
      state.mapLineOpen = false;
      state.showOpenLine = false;
      state.playNumber = 1;
      searchPersonRef.value.slotDisabled = false;
      mapLineOpenTimes(1);
    };
    // 展示地图操作按钮
    const getDrawArea = (value) => {
      console.log(value);
      if (mapRef.value) {
        let videoPoint = [];
        state.selectPoint = [];
        // 获取所有点位坐标
        videoPoint = state.videoData.map((element) => {
          element.location = [
            parseFloat(element.longitude),
            parseFloat(element.latitude),
          ];
          return element;
        });
        let selectPolygonPoint = [];
        let selectCirclPoint = [];

        value.forEach((element) => {
          if (!element.radius) {
            let selectPolygon = videoPoint.filter((item) => {
              let changeValue = element.corrdinates[0].map((el) => {
                return reverseVideoPoint(el);
              });
              if (util.isInsidePolygon(item.location, changeValue)) {
                return item;
              }
            });
            selectPolygonPoint.push(...selectPolygon);
          } else {
            selectCirclPoint = videoPoint.filter((item) => {
              element.loc = reverseVideoPoint(element.corrdinates);
              if (
                mapRef.value.getDistanceApi(item.location, element.loc) <
                element.radius
              ) {
                return item;
              }
            });
          }
          state.selectPoint = selectPolygonPoint.concat(selectCirclPoint);
        });
        if (state.selectPoint.length > 0) {
          //去重
          state.selectPoint = state.selectPoint.filter(
            (element, index, self) => {
              return (
                self.findIndex((x) => x.deviceId === element.deviceId) === index
              );
            }
          );
          state.showCreateTask = true;
        }
      }
    };
    // 关闭地图点位提示框
    const close = () => {
      state.showMapRender = false;
      state.showMapLineRender = false;
    };
    // 关闭新建任务框
    const closeTask = () => {
      state.showCreateTask = false;
      mapRef.value && mapRef.value.opertionBack();
      searchBoxRef.value && searchBoxRef.value.getClueTasks();
    };
    // 打开任务详情
    const opentaskDetail = (value) => {
      console.log(value);
      state.showTrackQuery = false;
      state.editTaskInfo = value;
      // getClueTaskIDAsync();
      // getRetrievalAsync();
      // getClueSnapTotalAsync();
    };

    //搜索范围中不同任务弹框
    const getSelectFeature = (val) => {
      console.log(val);
      state.queryFeature = val;
    };

    // 点击查询按钮
    const searchPersonMethod = (val) => {
      state.searchParams = val;
      state.showSearchPerson = true;
      state.queryFeature = val.searchImageSelectData;
      nextTick(() => {
        setTimeout(() => {
          searchPersonRef.value && searchPersonRef.value.refreshTable();
        }, 200);
      });
      // if (state.showSearchPerson) {
      //   state.queryFeature = val.searchImageSelectData;
      //   searchPersonRef.value && searchPersonRef.value.refreshTable();
      // } else {
      //   state.showSearchPerson = true;
      // }
    };
    // 退出
    const closeSearchPerson = (val) => {
      state.showSearchPerson = false;
      mapLineBack();
    };
    // 展开更多
    const unfold = () => {
      state.flag = !state.flag;
      console.log("展开", 1111);
    };
    const getPositionSearch = (e) => {
      let arr = state.videoData.filter((item) => {
        if (item.otherId == e[0].sourceId) {
          return item;
        }
      });
      state.mapDataItem = arr.length > 0 ? arr[0] : {};
      handleMapIconClick(e);
    };
    //打开地图选择摄像头
    const openSelectCamera = (e) => {
      state.isOpenFrame = false;
      state.defaultMap = false;
    };
    //打开地图选择摄像头
    const opertionBack = (selectVideo) => {
      state.isOpenFrame = true;
      state.defaultMap = true;
      setTimeout(() => {
        pointInfoArray(state.videoData);
        searchBoxRef.value && searchBoxRef.value.getTransferList(selectVideo);
      }, 300);
    };
    queryRealVideoTreeAsync();

    onUnmounted(() => {
      mapLineBack();
    });

    return {
      ...refData,
      mapRef,
      searchBoxRef,
      searchPersonRef,
      moment,
      trackQuery,
      popvoer,
      openOperation,
      close,
      getDrawArea,
      closeTask,
      opentaskDetail,
      searchPersonMethod,
      mapLineBack,
      mapLineDraw,
      getSelectFeature,
      mapLineOpenTimes,
      mapLineOpenClose,
      handleMapLineNode,
      closeArrayPointDom,
      getArrayPoint,
      unfold,
      getPositionSearch,
      closeSearchPerson,
      openSelectCamera,
      opertionBack,
      mapOpertionBack,
    };
  },
});
</script>
<style lang="scss" scoped>
.trackQuery {
  height: 100%;
  width: 100%;
  position: relative;
  .map-over {
    height: 100%;
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: center;
    .el-input {
      height: 30px;
      width: 80%;
      margin-top: 26px;
      font-size: 12px;
      z-index: 999;
      border-radius: 5px;

      // /deep/.el-input__inner {
      //   background-color: rgba(62, 69, 93, $alpha: 0.8) !important;
      //   color: #b6cef7;
      // }
    }
    .map-over-center {
      border-radius: 5px;
      width: 340px;
      height: calc(100% - 80px);
      padding: 20px 15px 0;

      &::after {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        border: 20px solid;
        border-color: transparent;
        border-left-color: #2b74dd;
        top: 40%;
        right: -40px;
      }
    }

    .map-over-bottom {
      border-radius: 5px;
      width: 340px;
      height: 48px;
      background-color: rgba(62, 69, 93, $alpha: 0.5);
      text-align: center;
      line-height: 48px;
      .iconfont {
        margin-left: 42%;
      }
    }
  }
  .create-task {
    position: absolute;
    top: 10%;
    right: 3%;
    width: 470px;
    // height: 321px;
    z-index: 10;
    border-radius: 10px;
    background-color: rgba(45, 60, 93, 0.8);
  }

  .openLine {
    position: absolute;
    bottom: 24px;
    right: 90px;
    z-index: 10;
    width: 200px;
    height: 40px;
    padding: 0 8px;
    border: 1px solid;
    border-radius: 20px;
    background-color: rgba(45, 60, 93, 0.8);
    color: #fff;
    @include flex-row-sa-c;
    span {
      cursor: pointer;
    }
  }
}
</style>
<style lang="scss">
.popoverSpeed {
  .speedTimes {
    height: 105px;
    display: flex;
    flex-direction: column;
    span {
      margin: 4px 0;
      cursor: pointer;
    }
  }
  .el-popper__arrow {
    display: none;
  }
}
.el-popover.el-popper {
  min-width: 10px;
}
</style>
